import { useEffect, useState } from "react";
import { getCars, addCar, updateCar, deleteCar } from "../services/api";
import toast, { Toaster } from "react-hot-toast";

export default function Cars() {
  const [cars, setCars] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [alerts, setAlerts] = useState([]);
  const [showAlert, setShowAlert] = useState(true);
  const [search, setSearch] = useState("");
  const [filteredCars, setFilteredCars] = useState([]);
  const [form, setForm] = useState({
    name: "",
    model: "",
    regNo: "",
    status: "Available",
    insuranceExpiry: ""
  });

  const [editId, setEditId] = useState(null);

  const fetchCars = async () => {
    const res = await getCars();
    const data = res.data;
    setCars(data);
    setFilteredCars(data);
    const today = new Date();

    const alertCars = data.filter((car) => {
      if (!car.insuranceExpiry) return false;
      const expiry = new Date(car.insuranceExpiry);
      const diff = (expiry - today) / (1000 * 60 * 60 * 24);
      return diff <= 7;
    });

    setAlerts(alertCars);
  };

  useEffect(() => {
    fetchCars();
  }, []);
  useEffect(() => {
  const value = search.toLowerCase();

  const result = cars.filter((car) =>
    car.name.toLowerCase().includes(value) ||
    car.model.toLowerCase().includes(value) ||
    car.regNo.toLowerCase().includes(value)
  );

  setFilteredCars(result);
}, [search, cars]);
  const validate = () => {
    if (!form.name.trim()) return "Car name required";
    if (!form.model.trim()) return "Model required";
    if (!form.regNo.trim()) return "Reg number required";
    if (!form.insuranceExpiry) return "Expiry date required";

    const regPattern = /^[A-Z]{2}\d{2}[A-Z]{2}\d{4}$/;
    if (!regPattern.test(form.regNo))
      return "Format: MH12AB1234";

    const today = new Date().setHours(0, 0, 0, 0);
    const selected = new Date(form.insuranceExpiry).setHours(0, 0, 0, 0);
   
    if (selected < today) return "Past date not allowed";

    return null;
  };

  const handleSubmit = async () => {
    const error = validate();
    if (error) return toast.error(error);

    try {
      if (editId) {
        await updateCar(editId, form);
        toast.success("Updated");
      } else {
        await addCar(form);
        toast.success("Added");
      }

      setForm({
        name: "",
        model: "",
        regNo: "",
        status: "Available",
        insuranceExpiry: ""
      });

      setShowForm(false);
      setEditId(null);
      fetchCars();
    } catch (err) {
  const message =
    err.response?.data?.msg ||
    err.response?.data?.error ||
    "Something went wrong";

  toast.error(message);
}
  };

  const handleEdit = (car) => {
    setForm({
      name: car.name || "",
      model: car.model || "",
      regNo: car.regNo || "",
      status: car.status || "Available",
      insuranceExpiry: car.insuranceExpiry
        ? car.insuranceExpiry.split("T")[0]
        : ""
    });
    setEditId(car._id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete?")) return;
    await deleteCar(id);
    fetchCars();
  };

  return (
    <>
      <Toaster />

      <style>{`
        .page {
          background: #f5f7fa;
          min-height: 100vh;
        }

        .header {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 10px;
        }

        .add-btn {
          background: #007bff;
          color: white;
          padding: 10px 15px;
          border-radius: 6px;
          cursor: pointer;
        }

        .card {
          background: white;
          padding: 20px;
          border-radius: 10px;
          margin-top: 15px;
          overflow-x: auto;
        }

        .form {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
          gap: 10px;
        }

        input, select {
          padding: 10px;
          border-radius: 6px;
          border: 1px solid #ddd;
        }

        button {
          padding: 10px;
          border: none;
          border-radius: 6px;
          cursor: pointer;
        }

        .primary {
          background: green;
          color: white;
        }

        table {
          width: 100%;
          border-collapse: collapse;
          min-width: 600px;
        }

        th, td {
          padding: 10px;
          border-bottom: 1px solid #eee;
          text-align: center;
        }

        th {
          background: #007bff;
          color: white;
        }

        .expired {
          background: #ffe5e5;
        }

        .alert-box {
          background: #ff4d4f;
          color: white;
          padding: 12px;
          border-radius: 6px;
          margin-bottom: 15px;
          position: relative;
        }

        .close-btn {
          position: absolute;
          top: 8px;
          right: 10px;
          cursor: pointer;
        }

        /* 🔥 RESPONSIVE ACTION BUTTONS */
        .actions {
          display: flex;
          gap: 5px;
          justify-content: center;
          flex-wrap: wrap;
        }

        .edit-btn {
          background: #ffa500;
          color: white;
          padding: 6px 10px;
        }

        .delete-btn {
          background: #dc3545;
          color: white;
          padding: 6px 10px;
        }

        @media (max-width: 600px) {
          .form {
            grid-template-columns: 1fr;
          }

          .actions {
            flex-direction: column;
          }

          .edit-btn, .delete-btn {
            width: 100%;
          }
        }
          .search-container {
  width: 100%;
  margin-bottom: 15px;
}

.search-input {
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #ddd;
  outline: none;
  font-size: 14px;
  transition: 0.3s;
}

.search-input:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(0,123,255,0.3);
}

@media (max-width: 600px) {
  .search-input {
    font-size: 13px;
    padding: 10px;
  }
}
      `}</style>
    <div className="search-container">
  <input
    className="search-input"
    placeholder="Search by name, model, reg no..."
    value={search}
    onChange={(e) => setSearch(e.target.value)}
  />
</div>
      <div className="page">

        {alerts.length > 0 && showAlert && (
          <div className="alert-box">
            <span className="close-btn" onClick={() => setShowAlert(false)}>X</span>
            Insurance Expiring Soon:
            {alerts.map((car) => (
              <div key={car._id}>
                {car.regNo} -{" "}
                {new Date(car.insuranceExpiry).toLocaleDateString()}
              </div>
            ))}
          </div>
        )}

        <div className="header">
          <h2>Car Management</h2>
          <div className="add-btn" onClick={() => setShowForm(!showForm)}>
            {showForm ? "Close" : "Add Car"}
          </div>
        </div>

        {showForm && (
          <div className="card">
            <div className="form">
              <input value={form.name} placeholder="Name"
                onChange={(e)=>setForm({...form,name:e.target.value})}/>
              <input value={form.model} placeholder="Model"
                onChange={(e)=>setForm({...form,model:e.target.value})}/>
              <input value={form.regNo} placeholder="Reg No"
                onChange={(e)=>setForm({...form,regNo:e.target.value.toUpperCase().replace(/\s/g,"")})}/>
              <input type="date" value={form.insuranceExpiry}
                onChange={(e)=>setForm({...form,insuranceExpiry:e.target.value})}/>
              <select value={form.status}
                onChange={(e)=>setForm({...form,status:e.target.value})}>
                <option>Available</option>
                <option>Booked</option>
                <option>Maintenance</option>
              </select>

              <button className="primary" onClick={handleSubmit}>
                {editId ? "Update" : "Add"}
              </button>
            </div>
          </div>
        )}

        <div className="card">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Model</th>
                <th>Reg No</th>
                <th>Status</th>
                <th>Expiry</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
                
              {filteredCars.map((car) => {
                const expired = car.insuranceExpiry &&
                  new Date(car.insuranceExpiry) < new Date();

                return (
                  <tr key={car._id} className={expired ? "expired" : ""}>
                    <td>{car.name}</td>
                    <td>{car.model}</td>
                    <td>{car.regNo}</td>
                    <td>{car.status}</td>
                    <td>
                      {car.insuranceExpiry
                        ? new Date(car.insuranceExpiry).toLocaleDateString()
                        : "-"}
                    </td>
                    {/* <td>{getStatus(car.insuranceExpiry)}</td> */}

                    {/* ✅ FIXED ACTIONS */}
                    <td>
                      <div className="actions">
                        <button
                          className="edit-btn"
                          onClick={() => handleEdit(car)}
                        >
                          Edit
                        </button>

                        <button
                          className="delete-btn"
                          onClick={() => handleDelete(car._id)}
                        >
                          Delete
                        </button>
                      </div>
                    </td>

                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

      </div>
    </>
  );
}